var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18.92,
    viewBox: "0 0 22 18.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e31e26;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.679,3.929a8.121,8.121,0,0,0-5.108,2.242A8.115,8.115,0,0,0,7.464,3.929,5.9,5.9,0,0,0,1.571,9.821c0,2.035,1.859,3.887,1.933,3.961l9.067,9.067,9.063-9.062c.079-.079,1.937-1.931,1.937-3.966A5.9,5.9,0,0,0,17.679,3.929Z",
    transform: "translate(-1.571 -3.929)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLike);
export default __webpack_public_path__ + "static/media/activity-like.572ac7448a40ec8de517dcf73a32fc32.svg";
export { ForwardRef as ReactComponent };